<template>
	<div class="module_page page_content institution" aria-label="Create Institution view content page">
	  <div class="hidden-container">
	    <form method="POST" id="multipleFileUploadForm" enctype="multipart/form-data" v-on:submit.prevent>
	      <input type="file" id="thumbnailFileList" ref="thumbnailFileList" name="thumbnailFile" @change="thumbnailToBeUploaded" />
	    </form>
	  </div>
	  <div class="row page-heading">
	    <div class="col-8 input module_heading" role="heading" aria-level="1">
	      <span class="module_icon ic-inst"></span>
	      <label class="head_txt module_type_name institution-title ace_sec_hd">{{this.title}}</label>
	    </div>
	    <div class="col-4 btn_container">
	      <b-btn @click="doneClicked">done</b-btn>
	      <b-btn @click="cancelClicked">cancel</b-btn>
	    </div>
	  </div>
	  <div class="page_content_container">
	    <institution-menu :uuid="uuid" :active="'create'"></institution-menu>
	    <div class="row pg_content">
	      <div class="col-12">
	        <div class="row">
	          <div class="col-12 pg_fld_sec">
	            <div class="row pg_fld_row">
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="row">
	                  <div class="col-12">
	                    <div class="fld_label">
	                      <label class="label">Institution Name</label> <span class="fld_req">*</span>
	                      <span id='nameInputField' class="exclamation-circle"><span class="ico-error"></span></span>
	                      <b-popover target="nameInputField" triggers="hover" container="nameInfo" :title="nameMustBeUniqueWarningText"></b-popover>
	                    </div>
	                    <div class="fld_input">
	                      <input v-model="title"></input>
	                    </div>
	                  </div>
	                </div>
	                <div class="row" style="margin-top: 30px;">
	                  <div class="col-12">
	                    <div class="fld_label">
	                      <label class="label" for="institutionLevel">Level</label>
	                    </div>
	                    <div class="fld_input">
	                      <select id="institutionLevel" v-model="level">
	                        <option v-for="level in institutionLevels" v-bind:value="level">
	                          {{ level }}
	                        </option>
	                      </select>
	                    </div>
	                  </div>
	                </div>
	              </div>
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="row">
	                  <div class="col-12">
	                    <div class="fld_label">
	                      <label class="label">Description</label>
	                    </div>
	                    <div class="fld_input">
	                      <textarea v-model="description" class="description"></textarea>
	                    </div>
	                  </div>
	                </div>
	              </div>
	            </div>
	            <div class="row pg_fld_row">
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label" for="institutionType">Type</label>
	                </div>
	                <div class="fld_input">
	                  <select id="institutionType" v-model="type">
	                    <option v-for="type in institutionTypes" v-bind:value="type">
	                      <!-- capitalize first letter -->
	                      {{ type.charAt(0).toUpperCase() + type.slice(1) }}
	                    </option>
	                  </select>
	                </div>
	              </div>
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label" for="orgType">Org Type</label>
	                </div>
	                <div class="fld_input">
	                  <select id="orgType" v-model="orgType">
	                    <option v-for="otype in orgTypes" v-bind:value="otype">
	                      <!-- capitalize first letter -->
	                      {{ otype }}
	                    </option>
	                  </select>
	                </div>
	              </div>
	            </div>
	            <div class="row pg_fld_row">
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">URL</label>
	                </div>
	                <div class="fld_input">
	                  <input v-model="uri" type="url"></input>
	                </div>
	              </div>
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">SSO URL</label>
	                </div>
	                <div class="fld_input">
	                  <input v-model="ssoUrl"></input>
	                </div>
	              </div>
	            </div>
	            <div class="row pg_fld_row">
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">SSO Path</label>
	                </div>
	                <div class="fld_input">
	                  <input v-model="path"></input>
	                </div>
	              </div>	            
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">SSO Logout URL</label>
	                </div>
	                <div class="fld_input">
	                  <input v-model="ssoLogoutUrl"></input>
	                </div>
	              </div>
	            </div>

	            <div class="row pg_fld_row">
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">Redirect URL after SSO</label>
	                </div>
	                <div class="fld_input">
	                  <input v-model="redirectUrl"></input>
	                </div>
	              </div>
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">Short Name</label>
	                </div>
	                <div class="fld_input">
	                  <b-form-input v-model.trim="shortName" @input="forceLowerCase($event, 'shortName')" @keydown.space.prevent style="height: 24px !important;"></b-form-input>
	                </div>
	              </div>
	            </div>
	            <div class="row pg_fld_row">
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">Parent Open Id</label>
	                </div>
	                <div class="fld_input">
	                  <b-form-input v-model.trim="parentOpenId" @input="forceUpperCase($event, 'parentOpenId')" style="height: 24px !important;"></b-form-input>
	                </div>
	              </div>
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">Open Id</label>
	                </div>
	                <div class="fld_input">
	                  <b-form-input v-model.trim="openId" @input="forceUpperCase($event, 'openId')" style="height: 24px !important;"></b-form-input>
	                </div>
	              </div>
	            </div>
	            <div class="row pg_fld_row">
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">Phone No.</label>
	                </div>
	                <div class="fld_input">
	                  <input v-model="phonenumber"></input>
	                </div>
	              </div>
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                  <div class="fld_label">
                    <label class="label">Fax No.</label>
                  </div>
                  <div class="fld_input">
                    <input v-model="faxnumber"></input>
                  </div>
	              </div>
	            </div>

	            <div class="row pg_fld_row">
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="row" style="margin-top: 30px;">
	                  <div class="col-12">
	                    <div class="fld_label">
	                      <label class="label" for="institutionType">Address</label>
	                    </div>
	                    <div class="fld_input">
	                      <textarea v-model="address" class="address"></textarea>
	                    </div>
	                  </div>
	                </div>
	              </div>
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="row">
	                  <div class="col-12">
	                    <div class="fld_label">
	                      <label class="label">Logo</label>
	                    </div>
	                    <div class="fld_input">
	                      <div class="thumbnail_container">
	                        <btn v-if="!showAddThumbnailModal" class="btn" @click="addThumbnailClicked">upload logo</btn>
	                        <img v-if="showPreview && logoUri" id="institutionThumbnail" :src="logoUri" class="thumbnail_image">
	                        <span v-else class="ic ico-buildingCollege"></span>
	                      </div>
	                      <b-modal ref="modal" id="addNewThumbnail" title="Update Thumbnail" v-model="showAddThumbnailModal" no-close-on-esc ok-only class="modal_popup popup_add_thumbnail">
	                        <div class="row">
	                          <div class="col-4">
	                            <div class="thumbnail_msg">How your thumbnail will appear</div>
	                            <div class="thumbnail_container">
	                              <img v-if="showPreview && logoUri" id="institutionThumbnail" :src="logoUri">
	                              <span v-else class="ic ico-buildingCollege"></span>
	                            </div>
	                            <span v-if="!showPreview">Preview unavailable</span>
	                          </div>
	                          <div class="col-7 right-model-box">
	                            <div class="row fld_row">
	                              <div class="col-1 fld_col_label">
	                                <label>URL</label>
	                              </div>
	                              <div class="col-8 fld_col_input">
	                                <input :disabled="isUploadingThumbnail" v-model="logoUri" placeholder="http://"></input>
	                              </div>
	                              <div class="col-3 btn_container">
	                              </div>
	                            </div>
	                            <div class="row fld_row msg_row">
	                              <div class="col-1"></div>
	                              <div class="col-11 msg">Add image url for thumbnail.</div>
	                            </div>
	                            <div class="row txt_sep_row">
	                              <div class="col-12">OR</div>
	                            </div>
	                            <div class="row fld_row">
	                              <div class="col-1 fld_col_label">
	                                <label for="newThumbnailFileName">File</label>
	                              </div>
	                              <div class="col-8 fld_col_input">
	                                <input id="newThumbnailFileName" disabled v-model="logo" placeholder="choose a file from your computer"></input>
	                                <b-btn v-if="isUploadingThumbnail || (logo && logo.length > 0)" @click.stop="removeThumbnailClicked" class="btn_remove"><span>x</span></b-btn>
	                              </div>
	                              <div class="col-3 fld_col_btn">
	                                <b-btn :disabled="isUploadingThumbnail" @click.stop="chooseFile(true)">add file</b-btn>
	                              </div>
	                            </div>
	                            <div class="row msg_row">
	                              <div class="col-1"></div>
	                              <div class="col-11 msg">Select a jpg, jpeg, bmp, gif or png file.</div>
	                            </div>
	                          </div>
	                        </div>
	                        <div slot="modal-footer">
	                          <b-btn @click="addNewThumbnail">save and next</b-btn>
	                          <b-btn @click="cancelAddThumbnail">cancel</b-btn>
	                        </div>
	                      </b-modal>
	                    </div>
	                  </div>
	                </div>
	              </div>
	            </div>
	            <div class="row pg_fld_row">
	              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
	                <div class="fld_label">
	                  <label class="label">Self Registration Custom Text</label>
	                </div>
	                <div class="fld_input">
	                  <editor api-key="no-api-key"
	                    v-model.trim="selfRegistrationMessage"
	                    :init="({
	                      base_url: 'https://cdnjs.cloudflare.com/ajax/libs/tinymce',
selector: 'textarea',
	                      menubar: false,
	                      plugins: plugins,
	                      toolbar: toolbar,
	                      branding: false,
	                      statusbar: false,
	                      end_container_on_empty_block: true
	                    })"
	                    @onInit="handlerInit"
	                    id="selfRegistrationMessageId">
	                  </editor>
	                </div>
	              </div>	              
	            </div>
	          </div>
	          <!-- .pg_fld_sec -->
	        </div>
	      </div>
	    </div>
	  </div>
	  <!-- .page_content_container -->
	  <div class="loading-spinner">
	    <b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-disabled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
	      <div class="text-center" style="color: #FFF">
	        <i class="fa fa-spinner fa-spin" style="font-size: 50px"></i>
	      </div>
	    </b-modal>
	  </div>
	</div>
</template>

<script>
/* global AWS:true */
import { mapState, mapActions } from 'vuex'
import InstitutionMenu from './InstitutionMenu'
import InstitutionHeader from './InstitutionHeader'
import { AwsObject } from '../aws'
import Editor from '@tinymce/tinymce-vue'
import _ from 'lodash'

var getFileName = function (fileName) {
  if (!fileName && fileName !== null) {
    return null
  }
  return fileName.replace(/\.\w+$/g, '')
}

var getUpdatedFileName = function (title, fileName) {
  var ext = fileName.substr((~-fileName.lastIndexOf('.') >>> 0) + 2)
  if (ext !== '' || ext !== null) {
    return (title + '.' + ext)
  } else {
    return fileName
  }
}

var FileObject = function (title, file, size, timestamp, type) {
  this.title = getFileName(title)
  this.file = file
  this.fileName = getUpdatedFileName(this.title, title)
  this.size = size
  this.contentFileType = type
  this.timestamp = timestamp
  this.id = timestamp
  // added
  // this.uri = file.uri
}

var clone = function (obj) {
  if (obj === null || typeof obj !== 'object') return obj
  var copy = obj.constructor()
  for (var attr in obj) {
    if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr]
  }
  return copy
}

export default {
  name: 'create-institution',
  props: [],
  components: {
  	Editor,
    InstitutionMenu,
    InstitutionHeader
  },
  data: () => {
    return {
      address: '',
      description: '',
      errors: [],
      faxnumber: '',
      fileUploadArray: [],
      institutionLevels: ['Graduate', 'Master', 'Certificate', 'Doctrate'],
      defaultLevel: 'Graduate',
      institutionTypes: ['online', 'campus'],
      orgTypes : ['INSTITUTION', 'EMPLOYER'],
      defaultType: 'online',
      isEditingThumbnail: false,
      level: '',
      lmsConnectorPackage: false,
      logo: '',
      logoCopy: '',
      logoUri: '',
      logoUriCopy: '',
      openId: '',
      parentOpenId: '',
      ssoUrl: '',
      ssoLogoutUrl:'',
      path: '',
      redirectUrl: '',
      phonenumber: '',
      showAddThumbnailModal: false,
      showPreview: true,
      title: '',
      type: '',
      orgType: 'INSTITUTION',
      uri: '',
      shortName: null,
      nameMustBeUniqueWarningText: 'Institution names must be unique',
      temporaryLearningSpaceId: 'Temp',
      selfRegistrationMessage: null,
      plugins: 'lists  autolink charmap code hr link textcolor',
      toolbar: 'bold italic | fontsizeselect | alignleft aligncenter alignright | forecolor backcolor | removeformat link unlink'
    }
  },
  mounted () {
    this.ownerId = localStorage.getItem('userid')
    this.level = this.defaultLevel
    this.type = this.defaultType
    this.loadCurrentEnvironment().then(res => {
      AwsObject(res)
    })
  },
  methods: {
    ...mapActions([
      'createInstitution',
      'loadUserAdvisor',
      'loadLogDashboardActivity',
      'uploadContentAndGetUri',
      'updateFileUriAndVersionIdAfterS3Upload',
      'loadCurrentEnvironment'
    ]),
    handlerInit (ev, editor) {
      $('#selfRegistrationMessageId_ifr').css({width: '100%', height: '123px', border: '1px solid #ccc'})
    },
    forceUpperCase (e, prop) {
      e = e.trim().toUpperCase()
      this.$set(this.$data, prop, e)
    },
    forceLowerCase (e, prop) {
      e = e.replace(' ', '').toLowerCase()
      this.$set(this.$data, prop, e)
    },
    cancelClicked () {
      return this.$router.push({ name: 'institutionList' })
    },
    doneClicked () {
      this.tryToCreateInstitution()
    },
    addThumbnailClicked () {
      this.showAddThumbnailModal = true
      this.isEditingThumbnail = true
      this.logoUriCopy = this.logoUri.slice(0)
      this.logoCopy = this.logo.slice(0)
    },
    removeThumbnailClicked () {
      this.isEditingThumbnail = true
      this.showPreview = true
      this.logo = ''
      this.logoUri = ''
    },
    cancelAddThumbnail () {
      this.logo = this.logoCopy
      this.logoUri = this.logoUriCopy
      this.isEditingThumbnail = false
      this.showAddThumbnailModal = false
      this.errors = []
      this.fileUploadArray = []
    },
    addNewThumbnail () {
      if (this.logo !== this.logoUri) {
        // user entered url instead of uploading local file, no upload necessary
        this.logo = this.logoUri
      } else {
        this.uploadFiles()
      }
      this.showAddThumbnailModal = false
      this.isEditingThumbnail = false
    },
    chooseFile () {
      $('input[type=file][id=thumbnailFileList]').click()
    },
    thumbnailToBeUploaded (ev) {
      this.fileUploadArray = []
      var files = ev.target.files || ev.dataTransfer.files
      if (!files.length || files.length <= 0) {
        return
      }
      this.logoUri = files[0].name
      this.logo = files[0].name
      this.prepareFileUploadArray(files)
      this.showPreview = false
    },
    prepareFileUploadArray (files) {
      if (!files || files.length === 0) {
        return
      }
      let timestamp = new Date().getTime()
      for (var i = 0; i < files.length; i++) {
        timestamp = timestamp + i
        this.addFileToUploadArray(files[i], timestamp)
      }
    },
    addFileToUploadArray (newFile, timestamp) {
      let isFound = _.find(this.fileUploadArray, function (file) {
        return ((newFile.name === file.title) && (newFile.size === file.size))
      })

      if (!isFound) {
        this.fileUploadArray.push(new FileObject(newFile.name, newFile, newFile.size, timestamp, newFile.type))
      }
    },
    uploadFiles () {
      let fileUploadArrayClone = clone(this.fileUploadArray)
      let contentListToCreate = []
      for (var i = 0; i < fileUploadArrayClone.length; i++) {
        let content = fileUploadArrayClone[i]
        let item = {
          'title': content.title,
          'lastModifiedDate': content.contentFileType.timestamp,
          'contentFileType': content.contentFileType,
          'fileName': content.fileName,
          'timestamp': content.timestamp,
          'logo': content.logo,
          'logoUri': content.logoUri
        }
        contentListToCreate.push(item)
      }
      if (contentListToCreate.length <= 0) {
        return
      }
      this.showLoader()
      this.uploadContentAndGetUri({
        learningSpaceId: this.temporaryLearningSpaceId, // learningSpaceId doesn't exist until after create call
        contents: contentListToCreate,
        success: this.uploadFileAfterCreateContentSuccessCallback,
        failure: this.uploadFileAfterCreateContentErrorCallback
      })
    },
    uploadFileAfterCreateContentSuccessCallback (response) {
      var createdContents = response.createdContents
      if (createdContents.length > 0) {
        // uploading files on S3 for created contents
        var fileUploadArrayClone = clone(this.fileUploadArray)
        this.uploadLearningContentFilesOnS3(createdContents, fileUploadArrayClone)
      }
      this.fileUploadArray = []
      this.showPreview = true
      this.showSuccessPopup()
    },
    uploadFileAfterCreateContentErrorCallback (response) {
      console.log('Error occured while creating content(s) ', response)
      this.hideLoader()
    },
    uploadLearningContentFilesOnS3 (createdContents, fileUploadArrayClone) {
      var filesToBeUploaded = []
      $.each(createdContents, (index, content) => {
        for (var i = 0; i < fileUploadArrayClone.length; i++) {
          var fileData = fileUploadArrayClone[i]
          if (content.fileName === fileData.fileName) {
            var key = content.uuid + '-' + content.fileName
            filesToBeUploaded.push({'uuid': content.uuid, 'key': key, 'uri': content.uri, 'fileData': fileData})
            break
          }
        }
      })
      if (filesToBeUploaded.length > 0) {
        this.storeFilesToS3(filesToBeUploaded)
      }
    },
    storeFilesToS3 (filesToBeUploaded) {
      var awsRef = new AWS.S3()
      var s3Bucket = this.currentEnvironment.s3Bucket
      $.each(filesToBeUploaded, (i, item) => {
        var params = {
          Key: item.key,
          Bucket: s3Bucket,
          ContentType: item.fileData.contentFileType,
          ACL: 'public-read',
          Body: item.fileData.file
        }
        awsRef.putObject(params, (err, data) => {
          if (err) {
            console.log('Uploading Learning Content File Failed On S3: ' + err.stack)
          } else {
            var uri = item.uri
            if (uri.indexOf('?versionId=') === -1) {
              uri = uri.concat('?versionId=' + data.VersionId)
              this.updateFileUriAndVersionIdAfterS3Upload({uuid: item.uuid, uri: uri})
            }
          }
          let logoData = filesToBeUploaded[0]
          this.logoUri = logoData.uri
          this.logo = logoData.uri
          this.hideLoader()
        })
      })
    },
    showSuccessPopup () {
      console.log('file upload successful!')
    },
    institutionDataIsValid () {
      let isValid = true
      if (!this.title) {
        isValid = false
        this.errors.push('Error: Institution \'Name\' cannot be blank')
      }
      return isValid
    },
    async tryToCreateInstitution () {
      if (!this.institutionDataIsValid()) {
        this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: this.errors.join('\n')
        })
        this.errors = []
        return
      }
      const institutionData = {
        title: this.title,
        level: this.level,
        description: this.description,
        type: this.type,
        orgType: this.orgType,
        uri: this.uri,
        address: this.address,
        phonenumber: this.phonenumber,
        faxnumber: this.faxnumber,
        openId: this.openId,
        parentOpenId: this.parentOpenId,
        ssoUrl: this.ssoUrl,
        ssoLogoutUrl: this.ssoLogoutUrl,
        path: this.path,
        redirectUrl: this.redirectUrl,
        logo: this.logo,
        shortName: this.shortName,
        autoProvision: false,
        autoProvisionRole: 'Student',
        autoTaggingEnable: false,
        courseDiscoveryConfigurationEnable: false,
        createPersonProfile: true,
        customLandingPageViewer: 'All',
        debugSearchRelevance: false,
        employmentDataProvider: 'O-Net',
        enableDashboard: false,
        enableExplore: false,
        guestUserSessionCount: 100,
        lmsConnectorPackage: false,
        mc3Integration: false,
        nlpSearchEnable: false,
        sharePlanningStream: false,
        showDefaultLandingPage: true,
        showDuplicateContent: false,
        streamPackage: false
      }
      if (this.selfRegistrationMessage) {
      	institutionData.selfRegistrationMessage = this.selfRegistrationMessage
      } else {
      	institutionData.selfRegistrationMessage = undefined
      }
      this.showLoader()
      let institution = await this.createInstitution({ institutionData: institutionData, ownerId: this.ownerId })
      this.hideLoader()
      if (this.isSuccessfulResponse(institution)) {
        let message = 'Institution "' + institution.title + '" created successfully.'
        this.notifySuccess(message)
        return this.$router.push({ name: 'institutionDetails', params: { uuid: institution.uuid } })
      } else {
      	let message = 'Institution with name "' + this.title + '" already exists, please choose a different name'
      	if(this.isInvalidParent(institution)){
      		message = 'Please enter a valid parent open Id.'
      	}
      	this.notifyFailure(message)
      }
    },
    showLoader () {
      if (this.$refs.loadingModal) {
        this.$refs.loadingModal.show()
      }
    },
    hideLoader () {
      if (this.$refs.loadingModal) {
        this.$refs.loadingModal.hide()
      }
    },
    isSuccessfulResponse (response) {
      return response && response.uuid
    },
    isInvalidParent (response) {
      return response && (response.message.indexOf('411') > 0)
    },
    notifySuccess (text) {
      this.$notify({
        group: 'notify',
        type: 'success',
        title: '',
        text: text
      })
    },
    notifyFailure (text) {
      this.$notify({
        group: 'notify',
        type: 'error',
        title: '',
        text: text
      })
    }
  },
  computed: {
    ...mapState({
      'institution': state => state.institution.institution,
      'currentEnvironment': state => state.learningContent.currentEnvironment
    })
  }
}
</script>

<style>
	.input-group {
	  z-index: 2;
	}

	.hidden-container {
	  visibility: hidden;
	  height: 1px;
	}

	.heading {
	  font-size: 20px;
	}

	.label {
	  font-size: 20px;
	  font-weight: bold;
	}

	.institution .mce-tinymce .mce-top-part {
    position: relative;
    background: #fafafa;
    width: 100%;
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/app/institution/components/CreateInstitution.vue